import React, { useContext } from 'react';

import DiscoveryContextV2 from '../../../contexts/discoveryContext/contextV2';
import Container from '../../../components/Container';
import BrowseLayout from './BrowseLayout';
import FindMobileLayout from './FindMobileLayout';
import FindDesktopLayout from './FindDesktopLayout';
import { useWindowSize } from '../../../hooks/useWindowSize';
import { breakpointLGInt } from '../../../base-styles/vars';
import { withLocationInfo } from '../provider';
import FilterBar from '../components/FilterBar';
import {
  filterBarContainer,
  filterBarContainerWrapper,
  boxSizeBorderBox,
} from '../styles.module.css';

// Conditionally chooses the category layout to render.
const CategoryLayout = ({
  injected: { location: { isLocationSetByUser } = {} },
  categoryData,
  ...props
}) => {
  const { width } = useWindowSize();
  const {
    activeFilters: { date, distance, tag },
  } = useContext(DiscoveryContextV2);

  if (!categoryData) return null;

  // Find Mode when any filter is active or when location is selected by user
  if (date || distance || tag || isLocationSetByUser) {
    // MOBILE LAYOUTS (includes tablet)
    if (width <= breakpointLGInt) {
      return <FindMobileLayout categoryData={categoryData} {...props} />;
    }

    return <FindDesktopLayout categoryData={categoryData} {...props} />;
  }

  return (
    <>
      <div className={filterBarContainerWrapper}>
        <Container className={filterBarContainer}>
          <FilterBar />
        </Container>
      </div>
      <div className={boxSizeBorderBox}>
        <BrowseLayout categoryData={categoryData} {...props} />
      </div>
    </>
  );
};

export default withLocationInfo(CategoryLayout);
